import { render } from "./rep130.vue?vue&type=template&id=defb08c2"
import script from "./rep130.vue?vue&type=script&lang=js"
export * from "./rep130.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__